import { defaultConfig } from '../config/bundlerConfig';

export async function apiClient({ getToken, projectId, path, init = {} }) {
  const token = getToken ? await getToken() : null;
  const res = await fetch(`${defaultConfig.SERVER_URL.url}${path}`, {
    ...init,
    // Use bearer token auth; avoids CORS + cookies complexity in dev.
    credentials: 'omit',
    headers: {
      'Content-Type': 'application/json',
      ...(init.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(projectId ? { 'X-Project-Id': projectId } : {}),
    },
  });
  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = {};
  }
  if (!res.ok) throw new Error(data?.error || `Request failed (${res.status})`);
  return data;
}

